<template>
	<div :class="[{'navigation' : this.$route.path === `/${PAGES.login}`}, 'notification-wrapper', {'white-notification':this.$route.meta.isGopRedesign}]">

		<transition-group
			appear enter-active-class="animate__animated animate__fadeInLeft"
			leave-active-class="animate__animated animate__fadeOutLeft"
			mode="out-in"
			style="position: relative; z-index: 999;"
		>
			<SingleNotification
				v-for="notification in getNotifications"
				:key="Number(notification.indexOfNotification)"
				:message="notification.message"
				:type="notification.type"
				:indexOfNotification="notification.indexOfNotification"/>
		</transition-group>

	</div>
</template>

<script>
import SingleNotification from '@/drc/components/notifications/SingleNotification';
import {PAGE_NAME} from "@/common/utils/constants.js";

export default {
	name: "Notification",
	components: {SingleNotification},
	computed: {
		getNotifications() {
			return this.$store.getters.getNotifications;
		}
	},
	data() {
		return {
			PAGES: PAGE_NAME,
		}
	}
}
</script>
